$(document).ready(function () {
  var ua = navigator.userAgent.toLowerCase(),
    event =
      ua.match(/Android/i) ||
      ua.match(/iPad/i) ||
      ua.match(/iPod/i) ||
      ua.match(/iPhone/i)
        ? "touchstart"
        : "click",
    isMobile = ua.match(/(iphone|ipod|ipad|android)/),
    window_w = $(window).width(),
    window_h = $(window).height(),
    is_home = $("body").hasClass("ishome");

  $.blockUI.defaults.message = "Aguarde.";

  /* $.cookieBar({
		message: LANG.cookies_txt,
		acceptText: LANG.cookies_btn,
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: LANG.cp_txt,
		policyURL: LANG.cp_url,
	}); */

  $("html").removeClass("no-js");

  if ("standalone" in window.navigator && window.navigator.standalone) {
    $("html").addClass("ios-standalone");
  }

  if ($.browser.msie) {
    $("html").addClass("is-ie");
    $("html").addClass("ie-" + $.browser.versionNumber);
  }

  if ($.browser.msedge) {
    $("html").addClass("is-edge");
  }

  if ($.browser.iphone && $.browser.safari) {
    $("html").addClass("ios-safari");
  }

  if ($.browser.iphone && $.browser.chrome) {
    $("html").addClass("ios-chrome");
  }

  if ($.browser.android && $.browser.chrome) {
    $("html").addClass("android-chrome");
  }

  $("#scroll-down-home a").click(function () {
    $("body,html").animate({ scrollTop: $(window).height() }, 800);
    return false;
  });

  $("#scroll-down-page a").click(function () {
    $("body,html").animate(
      { scrollTop: $(".page-header-container").height() },
      800
    );
    return false;
  });

  /**
   * Embed responsive
   */
  var iframe = $(".text iframe");
  if (iframe.length) {
    iframe.wrap("<div class='embed'></div>");
  }

  if ($("#form1").length) {
    tippy.delegate("#form1", {
      target: ".tippy",
    });
  }

  $("body").on("click", ".toggle:not(.close)", function (e) {
    e.preventDefault();
    blockScroll(1);
    $(".menu-mobile").addClass("show");
    $(this).addClass("close");
  });

  $("body").on("click", ".toggle.close", function (e) {
    e.preventDefault();
    if ($("#menu-principal").hasClass("show")) {
      $(".toggle").removeClass("back");
      $("#menu-principal").removeClass("show");
      $(".sub-menu").removeClass("show");
    } else {
      blockScroll(0);
      $(".menu-mobile").removeClass("show");
      $(this).removeClass("close");
    }
  });

  function blockScroll(block) {
    if (block == 1) {
      $("html").addClass("block-scroll");
    } else if (block == 0) {
      $("html").removeClass("block-scroll");
    }
  }

  $(window).on("scroll", function () {
    if (!$("header").hasClass("no-scrolled")) {
      if ($(this).scrollTop() > 100) $("header").addClass("scrolled");
      else $("header").removeClass("scrolled");
    }
  });
  $(window).trigger("scroll");

  $(".banner-slider").slick({
    dots: true,
    arrows: false,
    useTransform: false,
    slidesToShow: 1,
    infinite: false,
  });

  var swiper = new Swiper(".whatsnew-slider", {
    slidesPerView: 5,
    spaceBetween: 20,
    centeredSlides: true,
    on: {
      init: function () {
        var obj = $(".swiper-wrapper");
        var transformMatrix =
          obj.css("-webkit-transform") ||
          obj.css("-moz-transform") ||
          obj.css("-ms-transform") ||
          obj.css("-o-transform") ||
          obj.css("transform");
        var matrix = transformMatrix.replace(/[^0-9\-.,]/g, "").split(",");
        var x = matrix[12] || matrix[4]; //translate x
        // console.log(x);
        $(".whatsnew-pagination").css("left", parseInt(x) + "px");
      },
      reachEnd: function () {
        $(".whatsnew-overlay-content a.next").addClass("disabled");
        $(".whatsnew-overlay-content a.prev").removeClass("disabled");
      },
      reachBeginning: function () {
        $(".whatsnew-overlay-content a.prev").addClass("disabled");
        $(".whatsnew-overlay-content a.next").removeClass("disabled");
      },
    },
    breakpoints: {
      1400: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 4,
      },
      700: {
        slidesPerView: 3,
      },
      414: {
        slidesPerView: 2,
      },
      150: {
        slidesPerView: 1,
      },
    },
  });

  $(".whatsnew-overlay-content a.prev").click(function (e) {
    e.preventDefault();
    $(".swiper-slide-active").prev().removeClass("opaque");
    $(".whatsnew-overlay-content a.next").removeClass("disabled");
    swiper.slidePrev();
  });

  $(".whatsnew-overlay-content a.next").click(function (e) {
    e.preventDefault();
    $(".swiper-slide-active").addClass("opaque");
    $(".whatsnew-overlay-content a.prev").removeClass("disabled");
    swiper.slideNext();
  });

  /*$('.whatsnew-slider').on('init', function(event, slick)
	{
		if($(".whatsnew-slider-item").length <= slick.options.slidesToShow)
		{
			$(".whatsnew-pagination").css("display","none");
		}
		else
		{
			var l = parseInt($(".whatsnew-slider .slick-track").css("left"));
			$(".whatsnew-pagination").css("left",(l+60) + "px");
		}
	});

	$('.whatsnew-slider').slick({
        dots: false,
        arrows: false,
        useTransform:false,
		slidesToShow: 5,
		draggable:false,
		infinite:false,
		centerMode: true,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
				  slidesToShow: 4,
				  draggable:false
				}
			  },
			{
			  breakpoint: 992,
			  settings: {
				slidesToShow: 3,
				infinite:false,
				centerMode: false,
				draggable:false
			  }
			},
			{
			  breakpoint: 700,
			  settings: {
				slidesToShow: 2,
				infinite:false,
				centerMode: false,
				draggable:false
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				infinite:false,
				centerMode: false,
				draggable:false
			  }
			}
		]
    });

	// On before slide change
	$('.whatsnew-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

		if(currentSlide > nextSlide)
		{
			var el = $($(slick.$slides.get(currentSlide))).prev();
			el.removeClass("opaque");
		}
		else
		{
			var el = $($(slick.$slides.get(currentSlide)));
			el.addClass("opaque");
		}
	});

	$(".whatsnew-overlay-content a.prev").click(function(e)
	{
		e.preventDefault();
		$('.whatsnew-slider').slick('slickPrev');
	});

	$(".whatsnew-overlay-content a.next").click(function(e)
	{
		e.preventDefault();
		$('.whatsnew-slider').slick('slickNext');
	});*/

  /**
   * Trigger AOS
   */
  setTimeout(function () {
    $(".loading-container").fadeOut();
    AOS.init({
      offset: -50,
      disable: "mobile",
    });
  }, 300);

  /**
   * Fade loading images
   */
  var load_images_bg = $("body").find(
    ".load-img:not(.loaded), .load-img-uncover:not(.loaded)"
  );
  if (load_images_bg.length) {
    load_images_bg.each(function (index, element) {
      var image = new Image(),
        $element = $(element),
        is_bg_or_img = typeof $element.data("src") !== "undefined";

      image.onload = function () {
        if (is_bg_or_img) {
          $element
            .css("backgroundImage", "url('" + $element.attr("data-src") + "')")
            .removeAttr("data-src");
        }
        setTimeout(function () {
          $element.parent().removeClass("loading");
          $element.addClass("loaded");
        }, 200);
      };
      image.src = is_bg_or_img
        ? $element.attr("data-src")
        : $element.find("img").attr("src");
    });
  }

  /**
   * Lazy load images
   */
  var velcroLazy = {
    /**
     * init
     * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
     * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
     * ex: velcroLazy.init('.lazy');
     */
    init: (elements) => {
      let lazyImages = $(elements);

      if ("IntersectionObserver" in window) {
        var lazyImageObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var lazyImage = $(entry.target),
                image = lazyImage.find("img")[0] || new Image(),
                is_bg_or_img = typeof lazyImage.data("src") !== "undefined";

              image.onload = function () {
                if (is_bg_or_img) {
                  //is bg
                  lazyImage
                    .css(
                      "backgroundImage",
                      "url('" + lazyImage.data("src") + "')"
                    )
                    .removeAttr("data-src");
                }
                setTimeout(function () {
                  lazyImage
                    .addClass("loaded")
                    .removeClass("lazy")
                    .parent()
                    .removeClass("loading");
                }, 200);
              };

              image.src = is_bg_or_img
                ? lazyImage.data("src")
                : lazyImage.find("img").attr("data-src");
              lazyImageObserver.unobserve(entry.target);
            }
          });
        });

        lazyImages.each(function () {
          lazyImageObserver.observe(this);
        });
      } else {
        lazyImages.each(function () {
          var is_bg_or_img = typeof $(this).data("src") !== "undefined";
          if (is_bg_or_img) {
            //is bg
            $(this)
              .css("backgroundImage", "url('" + $(this).data("src") + "')")
              .removeAttr("data-src");
          } else {
            //is img
            $(this)
              .find("img")
              .attr("src", $(this).find("img").data("src"))
              .removeAttr("data-src");
          }
          $(this)
            .addClass("loaded")
            .removeClass("lazy")
            .parent()
            .removeClass("loading");
        });
      }
    },
  };

  var slide1, slide2, slide3, slide4, alltot, altval, getslider;
  var chktot = 100;
  var scrore = 101;

  //console.log($("#slide1").lenght);
  $(document).on("change", "#slide1, #slide2, #slide3, #slide4", function (e) {
    // Get the sliders Id
    getslider = $(this).attr("id");

    //Gather all slider values
    slide1 = parseInt($("input#slide1").val());
    // console.log(slide1);
    slide2 = parseInt($("input#slide2").val());
    slide3 = parseInt($("input#slide3").val());
    slide4 = parseInt($("input#slide4").val());
    alltot = slide1 + slide2 + slide3 + slide4;

    //check sliders total if greater than 150 and re-update slider
    if (alltot > chktot) {
      if (getslider == "slide1") {
        altval = chktot - slide2 - slide3 - slide4;
        $("input#slide1").val(altval).slider("refresh");
      }
      if (getslider == "slide2") {
        altval = chktot - slide1 - slide3 - slide4;
        $("input#slide2").val(altval).slider("refresh");
      }
      if (getslider == "slide3") {
        altval = chktot - slide1 - slide2 - slide4;
        $("input#slide3").val(altval).slider("refresh");
      }
      if (getslider == "slide4") {
        altval = chktot - slide1 - slide2 - slide3;
        $("input#slide4").val(altval).slider("refresh");
      }
    }

    //Update Total
    if (alltot < scrore) {
      // console.log(alltot);
    }
  });

  velcroLazy.init(".lazy");

  var root = $("html,body");
  function smoothScrollingTo(target) {
    var target = $(target);
    if (target.length) {
      root.animate(
        {
          scrollTop: target.offset().top - 100,
        },
        400,
        "swing"
      );
    }
  }

  $("#form_graphs").on("change", function (e) {
    e.preventDefault();
    //console.log($(this).attr("rel"));
    let id_impact = $("#form_graphs_impact").val();
    if (parseInt($(this).val()) > 0)
      window.location.href =
        $(this).attr("rel") +
        "?ID_engagement=" +
        $(this).val() +
        "&ID_impact=" +
        id_impact;
    else window.location.href = $(this).attr("rel");
  });
  $("#form_graphs_impact").on("change", function (e) {
    e.preventDefault();
    let id_engagement = $("#form_graphs").val();
    //console.log($(this).attr("rel"));
    if (parseInt($(this).val()) > 0)
      window.location.href =
        $(this).attr("rel") +
        +"?ID_engagement=" +
        id_engagement +
        "&ID_impact=" +
        $(this).val();
    else window.location.href = $(this).attr("rel");
  });

  $("a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)").on(
    "click",
    function (event) {
      smoothScrollingTo(this.hash);
      if ($(".menu-mobile").hasClass("show")) {
        toogleMenu();
      }
    }
  );

  smoothScrollingTo(location.hash);

  if (!Modernizr.objectfit) {
    $("body .objectfit").each(function () {
      var $container = $(this),
        imgUrl = $container.find("img").prop("src");
      if (imgUrl) {
        $container
          .css("backgroundImage", "url(" + imgUrl + ")")
          .addClass("compat-object-fit");
      }
    });
  }

  $(".slider-container").slick({
    arrows: false,
    fade: true,
    dots: true,
    draggable: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    pauseOnHover: false,
    pauseOnDotsHover: true,
    prevArrow: false,
    nextArrow: false,
    responsive: [],
  });

  /**
   * Scroll do menu
   */
  windowOnScroll();
  $(window).on("scroll", function () {
    windowOnScroll();
  });

  if ($("#graphs").length) {
    let $graphs = $("#graphs").find(".graph");

    $graphs.each(function (index) {
      let options = {
        series: [
          {
            name: "Mine",
            data: [$(this).data("mine")],
          },
          {
            name: "Others avg",
            data: [$(this).data("others")],
          },
          {
            name: "Minimum",
            data: [$(this).data("min")],
          },
        ],
        chart: {
          type: "bar",
          height: 250,
          toolbar: {
            show: false,
          },
        },
        colors: ["#F9BA9F", "#D7A7B1", "#6BCCDE"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 10,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Mine", "Others avg", "Minimum"],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };

      let chart = new ApexCharts($(this)[0], options);

      chart.render();
    });
  }

  if ($("#graphs2").length) {
    let $graphs = $("#graphs2").find(".graph");

    $graphs.each(function (index) {
      let options = {
        series: [
          {
            name: "Mine",
            data: [$(this).data("mine")],
          },
          {
            name: "Others avg",
            data: [$(this).data("others")],
          },
          {
            name: "Minimum",
            data: [$(this).data("min")],
          },
        ],
        chart: {
          type: "bar",
          height: 250,
          toolbar: {
            show: false,
          },
        },
        colors: ["#F9BA9F", "#D7A7B1", "#6BCCDE"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 10,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Mine", "Others avg", "Minimum"],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };

      let chart1 = new ApexCharts($(this)[0], options);
      // console.log(chart1);
      chart1.render();
    });
  }
});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
  if (block == 1) {
    $("html").addClass("block-scroll");
  } else if (block == 0) {
    $("html").removeClass("block-scroll");
  }
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
  var checked = form.find('input[name="checkpolicy[]"]:checked').length;
  if (checked === 1) {
    return true;
  }

  return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
  if (
    $(window).scrollTop() > 45 &&
    $(".site-header").hasClass("big") &&
    $(".site-header").hasClass("should-big")
  ) {
    $(".site-header").removeClass("big");
  } else if (
    $(window).scrollTop() <= 45 &&
    !$(".site-header").hasClass("big") &&
    $(".site-header").hasClass("should-big")
  ) {
    $(".site-header").addClass("big");
  }
}

var app_form_1 = new Vue({
  el: "#form1",
  data: {
    feedback: {
      message: "",
      class: "",
    },
    chktot: 100,
    scrore: 101,
    step: 1,
    totalsteps: 2,
    result: 2,
    area: 1,
    div: 1,
    how_many_members: 5,
    stakeholder_groups: [],
    stakeholder_groups_other: "",
    common_direction: [],
    common_direction_other: "",
    documents: "no",
    documents_value: [],
    documents_agenda: "no",
    documents_agenda_value: [],
    max: 100,
    min: 0,
    //selectedAnswer:[],
    ranges: {
      how_many_members_change_agency: 0,
      how_many_members_active_members: 0,
      how_many_members_occasional_members: 0,
      how_many_members_peripheral_members: 0,
    },
    how_many_members_cannot_provide: "",
    evaluative_activities: [],
    common_direction_disabled: 0,
  },

  methods: {
    /**
     * SLIDER UPDATE
     */

    doSomething: function (current_slide) {
      let current_slide_id = $(current_slide).attr("id");
      let slider1 = Number(document.getElementById("slider1").value);
      let slider2 = Number(document.getElementById("slider2").value);
      let slider3 = Number(document.getElementById("slider3").value);
      let slider4 = Number(document.getElementById("slider4").value);

      let tot = slider1 + slider2 + slider3 + slider4;

      if (tot > 100) {
        if (current_slide_id == "slider1") {
          let altval = 100 - slider2 - slider3 - slider4;
          $("#slider1").val(altval);
          this.ranges.how_many_members_change_agency = altval;
        }
        if (current_slide_id == "slider2") {
          let altval = 100 - slider1 - slider3 - slider4;
          $("#slider2").val(altval);
          this.ranges.how_many_members_active_members = altval;
        }
        if (current_slide_id == "slider3") {
          let altval = 100 - slider2 - slider1 - slider4;
          $("#slider3").val(altval);
          this.ranges.how_many_members_occasional_members = altval;
        }
        if (current_slide_id == "slider4") {
          let altval = 100 - slider2 - slider3 - slider1;
          $("#slider4").val(altval);
          this.ranges.how_many_members_peripheral_members = altval;
        }
        //console.log(current_slide_id);
        //alert("Danger");
      }

      //console.log(tot);
    },

    /**
     * showForm
     */
    showForm: function () {
      this.step = 2;
      window.scrollTo(0, 0);
    },

    dontUnderstandCommonDirection: function () {
      var $this = this;
      $this.common_direction.forEach((element) => {
        if (element == "dont-understand") {
          $this.common_direction_disabled = 1;
          $this.common_direction_other = "";
        } else {
          $this.common_direction_disabled = 0;
        }
      });
    },

    /**
     * Submeter
     */
    submitForm: function (e) {
      var $this = this;
      var form = $(e.target);
      var fields = $(e.target).serialize();
      $this.feedback.message = "";

      $.blockUI({
        message: "<h5>Stand by</h5>",
      });

      fields += "&action=form1_ajax";

      $.ajax({
        url: main_script.ajaxurl,
        type: "POST",
        data: fields,
        dataType: "json",
        success: function (r) {
          if (r.success) {
            form[0].reset();

            $this.how_many_members = 5;
            $this.stakeholder_groups = [];
            $this.stakeholder_groups_other = "";
            $this.common_direction = [];
            $this.common_direction_other = "";
            $this.documents = "no";
            $this.documents_value = [];
            $this.documents_agenda = "no";
            $this.documents_agenda_value = [];
            $this.ranges.how_many_members_change_agency = 0;
            $this.ranges.how_many_members_active_members = 0;
            $this.ranges.how_many_members_occasional_members = 0;
            $this.ranges.how_many_members_peripheral_members = 0;
            $this.how_many_members_cannot_provide = "";
            $this.evaluative_activities = [];
            $this.common_direction_disabled = 0;

            setTimeout(() => {
              window.location.href = r.data.redirect;
            }, 1000);
          }
          //$this.feedback.message = r.data;
          if (r.success == true) {
            //console.log(r.data.message);
            $this.feedback.message = r.data.message;
          } else {
            $this.feedback.message = r.data;
          }
          $this.feedback.class = r.success ? "ok" : "error";

          $.unblockUI();
        },
        error: function (r) {
          $this.feedback.message = "Ocorreu um erro";
          $this.feedback.class = "error";
          $.unblockUI();
        },
      });
    },
  },
});

var app_form_2 = new Vue({
  el: "#form2",
  data: {
    feedback: {
      message: "",
      class: "",
    },
    show: 0,
    step: 1,
    totalsteps: 2,
    result: 2,
    area: 1,
    div: 1,
    trained_agents_involvement: "no",
    common_funding: [],
    common_activities: [],
    emergent_meaning: [],
    notable_changes: [],
    change_achievement: "",
    implement_evaluative: [],
    relate_method: [],
    exploit_monitoring: "",
    // max: 100,
  },

  methods: {
    /**
     * showForm
     */
    showForm: function () {
      this.step = 2;
      window.scrollTo(0, 0);
    },

    /**
     * Submeter
     */
    submitForm: function (e) {
      var $this = this;
      var form = $(e.target);
      var fields = $(e.target).serialize();
      $this.feedback.message = "";

      $.blockUI({
        message: "<h5>Stand by</h5>",
      });

      fields += "&action=form2_ajax";

      $.ajax({
        url: main_script.ajaxurl,
        type: "POST",
        data: fields,
        dataType: "json",
        success: function (r) {
          if (r.success) {
            form[0].reset();

            $this.trained_agents_involvement = "no";
            $this.common_funding = [];
            $this.common_activities = [];
            $this.emergent_meaning = [];
            $this.notable_changes = [];
            $this.change_achievement = "";
            $this.implement_evaluative = [];
            $this.relate_method = [];
            $this.exploit_monitoring = "";

            setTimeout(() => {
              window.location.href = r.data.redirect;
            }, 1000);
          }

          if (r.success == true) {
            $this.feedback.message = r.data.message;
          } else {
            $this.feedback.message = r.data;
          }
          $this.feedback.class = r.success ? "ok" : "error";

          $.unblockUI();
        },
        error: function (r) {
          //console.log(r);
          $this.feedback.message = "Ocorreu um erro";
          $this.feedback.class = "error";
          $.unblockUI();
        },
      });
    },
  },
});
